import { t } from 'i18next';
import React from 'react';

export enum InvoiceStatus {
    NONE = 0,
    PREPAYMENT = 1,
    CONFIRMED = 2,
}

interface InvoiceStatusProps {
    invoiceStatus?: InvoiceStatus;
}

interface InvoiceStatusOption {
    id: number;
    name: string;
}

const InvoiceStatusComponent: React.FC<InvoiceStatusProps> = ({ invoiceStatus }) => {
    switch (invoiceStatus) {
        case InvoiceStatus.NONE:
            return <span>{t('None')}</span>;
        case InvoiceStatus.PREPAYMENT:
            return <span>{t('PrePayment')}</span>;
        case InvoiceStatus.CONFIRMED:
            return <span>{t('Confirmed')}</span>;
        default:
            return <span>{t('Unknown')}</span>;
    }
};

export const getInvoiceStatusById = (statusId: number): InvoiceStatusOption => {
    const status = getAllInvoiceStatuses().find((s) => s.id === statusId);
    return status ?? {
        id: statusId,
        name: t('Unknown'),
    };
};

export const getInvoiceStatusString = (statusId: number): string => {
    return getInvoiceStatusById(statusId).name;
};

export const getAllInvoiceStatuses = (): InvoiceStatusOption[] => {
    return [
        {
            id: InvoiceStatus.NONE,
            name: t('None'),
        },
        {
            id: InvoiceStatus.PREPAYMENT,
            name: t('PrePayment'),
        },
        {
            id: InvoiceStatus.CONFIRMED,
            name: t('Confirmed'),
        },
    ];
};

export default InvoiceStatusComponent;
